import { dateToDateOnlyApiFormat, getDatesInRange } from '@/helpers/dateHelper';
import { handleMutation } from '@/helpers/toastHelper';
import { useConfirm } from '@/services/confirm/ConfirmationService';
import {
  UpdateAvailabilityExceptionDetail,
  useUpdateAvailabilityExceptionsDirectlyMutation
} from '@/services/gql/graphql.generated';
import { useState } from 'react';

export const useManagerBookLeave = (employeeId: string) => {
  const [, updateExceptionsDirectly] = useUpdateAvailabilityExceptionsDirectlyMutation();
  const [fetching, setFetching] = useState(false);
  const unregisterConfirmation = useConfirm(state => state.unregisterForConfirmation);

  const bookLeave = async (start: Date, end: Date, leaveTypeId: string) => {
    const exceptions: UpdateAvailabilityExceptionDetail[] = getDatesInRange(start, end).map(date => ({
      date: dateToDateOnlyApiFormat(date),
      leaveTypeId
    }));

    setFetching(true);
    try {
      return await handleMutation(
        () =>
          updateExceptionsDirectly({
            exceptions: {
              employeeExceptions: [{ employeeId, exceptions }],
              start: dateToDateOnlyApiFormat(start),
              end: dateToDateOnlyApiFormat(end)
            }
          }),
        {
          successMessage: 'Leave booked successfully.',
          onSuccess: unregisterConfirmation
        }
      );
    } finally {
      setFetching(false);
    }
  };

  return { bookLeave, fetching };
};
